import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayByShift } from "../models/DelayByShift";
const moment = getMomentTz();

export const getDelaysByShift = async (
	params: {
		shiftId: number | null;
		delayAreaAssetId?: number | null;
		includeMicroDelays?: boolean;
		onlyUndeclared?: boolean;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ShiftId", value: params.shiftId || 0 },
		{ name: "IncludeMicroDelays", value: params.includeMicroDelays || false },
		{ name: "OnlyUndeclared", value: params.onlyUndeclared || false },
	];

	if (params.delayAreaAssetId)
		parameters.push({ name: "AssetId", value: params.delayAreaAssetId });

	const resp = await apiService.callV2(
		"[DEL].[GetDelaysByShift]",
		parameters,
		signal,
	);
	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((delay: DelayByShift) => ({
			...delay,
			Start: delay.Start ? moment.utc(delay["Start"]).toDate() : null,
			End: delay.End ? moment.utc(delay["End"]).toDate() : null,
		}));

		return rows as DelayByShift[];
	} else {
		throw new Error(resp.message || "Error fetching delays");
	}
};

export const getDelay = async (
	params: { delayId: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DelayId", value: params.delayId },
	];

	const resp = await apiService.callV2("[DEL].[GetDelay]", parameters, signal);
	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((delay: DelayByShift) => ({
			...delay,
			Start: delay.Start ? moment.utc(delay["Start"]).toDate() : null,
			End: delay.End ? moment.utc(delay["End"]).toDate() : null,
		}));

		return rows as DelayByShift[];
	} else {
		throw new Error(resp.message || "Error fetching delay");
	}
};

export const upsertDelay = async (
	DelayId: number | null,
	AssetId: number | null,
	Start: Date | null,
	End: Date | null,
	DelayCodeId: number | null,
	DelayCategoryId: number | null,
	Comments: string | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DelayId", value: DelayId },
		{ name: "AssetId", value: AssetId },
		{
			name: "Start",
			value: Start ? Start.toISOString() : null,
		},
		{
			name: "End",
			value: End ? End.toISOString() : null,
		},
		{ name: "DelayCodeId", value: DelayCodeId },
		{ name: "DelayCategoryId", value: DelayCategoryId },
		{ name: "Comments", value: Comments },
	];

	return await apiService.callV2("[DEL].[UpsertManualDelay]", parameters);
};

export const justifyDelay = async (
	delayId: number,
	delayCodeId: number | null,
	delayCategoryId: number | null,
	comments: string | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DelayId", value: delayId },
		{ name: "DelayCodeId", value: delayCodeId === 0 ? null : delayCodeId },
		{ name: "DelayCategoryId", value: delayCategoryId },
		{ name: "Comments", value: comments },
	];

	return await apiService.callV2("[DEL].[JustifyDelay]", parameters);
};

export const deleteDelay = async (delayId: number | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "DelayId", value: delayId }];

	return await apiService.callV2("[DEL].[DeleteManualDelay]", parameters);
};

export const splitDelay = async (
	delay1: DelayByShift,
	delay2: DelayByShift,
) => {
	const apiService = new MESApiService();
	const splitTime = delay1.End?.toISOString();
	const parameters: spParameter[] = [
		{ name: "DelayId", value: delay1.DelayId },
		{ name: "SplitTime", value: splitTime! },
		{ name: "DelayCodeId1", value: delay1.DelayCodeId },
		{ name: "DelayCodeId2", value: delay2.DelayCodeId },
		{ name: "DelayCategoryId1", value: delay1.DelayCategoryId },
		{ name: "DelayCategoryId2", value: delay2.DelayCategoryId },
		{ name: "Comments1", value: delay1.Comments },
		{ name: "Comments2", value: delay2.Comments },
	];
	return await apiService.callV2("[DEL].[SplitDelay]", parameters);
};
